import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface ContactInfo {
  id: string;
  phone: string | null;
  email: string | null;
  address: string | null;
  opening_hours: string | null;
  ico: string | null;
  dic: string | null;
  bank_account: string | null;
}

// Default fallback values
const defaultContactInfo: ContactInfo = {
  id: '',
  phone: '+420 732 658 712',
  email: 'josefkotrba@post.cz',
  address: 'Teplice a okolí',
  opening_hours: 'Po-Pá: 8:00 - 17:00',
  ico: '09930761',
  dic: null,
  bank_account: null,
};

export const useContactInfo = () => {
  const [contactInfo, setContactInfo] = useState<ContactInfo>(defaultContactInfo);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContactInfo = async () => {
      const { data, error } = await supabase
        .from('contact_info')
        .select('*')
        .single();
      
      if (!error && data) {
        setContactInfo(data);
      }
      setLoading(false);
    };

    fetchContactInfo();
  }, []);

  return { contactInfo, loading };
};
